import React, { SyntheticEvent } from "react";

import { FormErrors } from "./ui/form-errors";

import _ from "lodash";

import { ProfileContainer } from "./containers/profile-container";
import { LoadingContainer } from "./containers/loading-container";

import { useEventCallback } from "rxjs-hooks";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import {
  validImageType,
  ValidationResult,
  ACCEPTED_IMAGE_TYPES
} from "../lib/form-validators";

interface Props {
  profileContainer: ProfileContainer;
  loadingContainer: LoadingContainer;
}

const AvatarUploader = ({
  profileContainer,
  loadingContainer
}: Props): JSX.Element => {
  const [avatarUploadCallback, [errors]] = useEventCallback(
    (event$: Observable<React.ChangeEvent<HTMLInputElement>>) =>
      event$.pipe(
        map((e: SyntheticEvent<HTMLInputElement>) => {
          let file: File | undefined = _.head(
            (e.nativeEvent.target as HTMLInputElement).files
          );

          let validationMessage: ValidationResult = validImageType(
            file!["type"]
          );

          if (!_.isNil(validationMessage)) return [validationMessage];

          loadingContainer.setLoading("avatar");

          profileContainer
            .uploadAvatar(file)
            .finally(() => loadingContainer.setLoaded("avatar"));

          return [undefined];
        })
      ),
    [undefined]
  );

  return (
    <form>
      <div className="form-group">
        <label>
          <a className="dc-link_bare">
            Upload/Change Photo
            {loadingContainer.isLoading("avatar") && [
              <span
                key={1}
                className="spinner-grow spinner-grow-sm"
                role="status"
                aria-hidden="true"
              />,
              " "
            ]}
            <input
              disabled={loadingContainer.isLoading("avatar")}
              hidden={true}
              accept={_.join(ACCEPTED_IMAGE_TYPES)}
              className="form-control-file"
              onChange={avatarUploadCallback}
              type="file"
            />
          </a>
        </label>
        <FormErrors submitError={errors} />
      </div>
    </form>
  );
};

export { AvatarUploader };
